import React from 'react';
import { SwitchRoot, SwitchThumb } from './styles';

export default ({ ...props }) => (
  <SwitchRoot {...props}>
    <SwitchThumb />
  </SwitchRoot>
);